import { expected } from '@aloft/toolkit-shared';

import { MarketAdjustmentsChartDisplay } from '../../../redux/features/selectors/calculatedMarketAdjustmentSelectors/selectMarketAdjustmentsDisplay.ts';
import { getHistoricalAvgPricePerMonthData } from '../../marketConditions/customAvgPricePerMonth/getHistoricalAvgPricePerMonthData.ts';
import { Tkv2MarketConditionsState } from '../../marketConditions/types.ts';
import { getHousingTrendsChartData } from '../../marketConditions/utils/getHousingTrendsChartData.ts';
import { ZillowHomeValueIndexTrendsChartUnwrapped } from '../../marketConditions/zillow/ZillowHomeValueIndexTrendsChart.tsx';
import { ZillowHomeValueIndexTrendsData } from '../../marketConditions/zillow/types.ts';
import { IMAGE_FACTOR, PNG_HEIGHT, PNG_WIDTH } from './constants.ts';
import { pngChartMaker } from './pngChartMaker.tsx';

const sharedChartProps = {
  disableAnimations: true,
  width: PNG_WIDTH * IMAGE_FACTOR,
  height: PNG_HEIGHT * IMAGE_FACTOR,
};

/**
 * @deprecated
 */
export const pngHomeValueIndexTrendsChartMaker = async (
  filteredHousingTrendsData: ZillowHomeValueIndexTrendsData | undefined,
  marketConditionsState: Tkv2MarketConditionsState,
): Promise<string | undefined> => {
  if (marketConditionsState.dateOfSaleAdjustment.selectedMethod === 'customAvgPricePerMonth') {
    const historicalData = getHistoricalAvgPricePerMonthData(
      marketConditionsState.effectiveDate,
      expected(marketConditionsState.dateOfSaleAdjustment.methods?.customAvgPricePerMonth?.trends),
    );

    return pngChartMaker(ZillowHomeValueIndexTrendsChartUnwrapped, {
      isZillow: false,
      data: historicalData.map((trend) => ({
        inner: trend,
        month: trend.month,
        historical: trend.typicalValue.toDollarLike(),
        projection: null,
      })),
      ...sharedChartProps,
      effectiveDate: marketConditionsState.effectiveDate,
    });
  }

  if (!filteredHousingTrendsData) return undefined;

  return pngChartMaker(ZillowHomeValueIndexTrendsChartUnwrapped, {
    isZillow: filteredHousingTrendsData?.isZillow ?? false,
    data: getHousingTrendsChartData(filteredHousingTrendsData),
    ...sharedChartProps,
    effectiveDate: filteredHousingTrendsData.effectiveDate,
  });
};

export const pngHomeValueIndexTrendsChartMakerV2 = async (
  data?: MarketAdjustmentsChartDisplay,
): Promise<string | undefined> => {
  if (!data) return undefined;

  return pngChartMaker(ZillowHomeValueIndexTrendsChartUnwrapped, {
    ...data,
    ...sharedChartProps,
  });
};
